var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "columns is-multiline d-flex flex-column flex-md-row" },
    [
      _c(
        "section",
        {
          staticClass: "sidebar column is-full-mobile is-4-tablet is-3-desktop"
        },
        [_vm._m(0), _vm._v(" "), _c("cat-uxo-stacked-ads")],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "uxo-type column is-offset-1-desktop is-8 p-0" },
        [
          !_vm.fetchingIncidents
            ? [
                _vm.incidentsCount > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "columns is-mobile align-items-center mb-2"
                      },
                      [
                        _c("h1", { staticClass: "column is-half" }, [
                          _vm._v("IED Incidents")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "total-items font-style-16 column d-flex justify-content-end align-items-end"
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.incidentsCount) +
                                " results\n                "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("cat-uxo-incidents", {
                  staticClass: "columns is-mobile is-multiline"
                })
              ]
            : [
                _c(
                  "div",
                  { staticClass: "content-loader" },
                  [
                    _c(
                      "ContentLoader",
                      {
                        staticClass: "mb-2",
                        attrs: {
                          height: 56,
                          width: 720,
                          speed: 2,
                          primaryColor: "#f3f3f3",
                          secondaryColor: "#ecebeb"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "460",
                            height: "56"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "56"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ContentLoader",
                      {
                        attrs: {
                          height: 240,
                          width: 720,
                          speed: 2,
                          primaryColor: "#f3f3f3",
                          secondaryColor: "#ecebeb"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "176",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "336",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "156",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "176",
                            y: "155",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "336",
                            y: "154",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "154",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ContentLoader",
                      {
                        attrs: {
                          height: 240,
                          width: 720,
                          speed: 2,
                          primaryColor: "#f3f3f3",
                          secondaryColor: "#ecebeb"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "176",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "336",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "156",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "176",
                            y: "155",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "336",
                            y: "154",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "154",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ContentLoader",
                      {
                        attrs: {
                          height: 240,
                          width: 720,
                          speed: 2,
                          primaryColor: "#f3f3f3",
                          secondaryColor: "#ecebeb"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "176",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "336",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "156",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "176",
                            y: "155",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "336",
                            y: "154",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "154",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ContentLoader",
                      {
                        attrs: {
                          height: 240,
                          width: 720,
                          speed: 2,
                          primaryColor: "#f3f3f3",
                          secondaryColor: "#ecebeb"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "176",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "336",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "156",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "176",
                            y: "155",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "336",
                            y: "154",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "154",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ContentLoader",
                      {
                        attrs: {
                          height: 240,
                          width: 720,
                          speed: 2,
                          primaryColor: "#f3f3f3",
                          secondaryColor: "#ecebeb"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "176",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "336",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "156",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "176",
                            y: "155",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "336",
                            y: "154",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "154",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ContentLoader",
                      {
                        attrs: {
                          height: 240,
                          width: 720,
                          speed: 2,
                          primaryColor: "#f3f3f3",
                          secondaryColor: "#ecebeb"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "176",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "336",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "156",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "176",
                            y: "155",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "336",
                            y: "154",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "154",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ContentLoader",
                      {
                        attrs: {
                          height: 240,
                          width: 720,
                          speed: 2,
                          primaryColor: "#f3f3f3",
                          secondaryColor: "#ecebeb"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "176",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "336",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "0",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "140"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "16",
                            y: "156",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "176",
                            y: "155",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "336",
                            y: "154",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        }),
                        _vm._v(" "),
                        _c("rect", {
                          attrs: {
                            x: "492",
                            y: "154",
                            rx: "0",
                            ry: "0",
                            width: "140",
                            height: "24"
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ],
          _vm._v(" "),
          _vm.pageCount
            ? _c("div", { staticClass: "columns mb-4 mb-lg-0" }, [
                _c(
                  "div",
                  { staticClass: "column is-6 py-0 mx-auto" },
                  [
                    _c("paginate", {
                      attrs: {
                        "page-count": _vm.pageCount,
                        "prev-text": "&nbsp;",
                        "next-text": "&nbsp;",
                        "prev-link-class": "pagination-previous",
                        "next-link-class": "pagination-next",
                        "container-class": "pagination-list",
                        "page-class": "pagination-item",
                        "page-link-class": "pagination-link",
                        "click-handler": _vm.paginate
                      }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h4", { staticClass: "mb-2 text-center" }, [
        _vm._v("Download the CAT-UXO App ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "app-download-buttons d-flex mb-4" }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href:
                "https://apps.apple.com/by/app/cat-uxo/id6720751417?platform=iphone"
            }
          },
          [
            _c("img", {
              attrs: { src: "/img/download-on-the-app-store.png", alt: "" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://play.google.com/store/apps/details?id=com.catuxo.mobile&hl=en"
            }
          },
          [
            _c("img", {
              attrs: { src: "/img/get-it-on-google-play.png", alt: "" }
            })
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ae20028a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae20028a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/Incidents.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-ae20028a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/Incidents.vue
// module chunks = 0 1